/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

 var Nav = {
  headerSectionElement: null,

  init: function() {

    // Get all the elements that can toggle panels
    let panelToggleButtons = document.querySelectorAll("[data-toggle-panel]");

    // Iterate element we found
    panelToggleButtons.forEach(toggleButton => {
      // Add a click event listener to the element
      toggleButton.addEventListener("click", function() {
        // Get the ID of the panel to toggle
        let panelIndexToToggle = toggleButton.dataset.togglePanel;

        // Get the panel itself by ID TODO: Fix name prefix 'nav-mobile-'
        let panel = document.getElementById("nav-mobile-" + panelIndexToToggle);

        // Check if we're already animating - if so, return and do nothing
        if(panel.classList.contains("animation-fade-slide-right")) {
          return;
        }

        // Check if we're currently in the show state - if so, hide
        if(panel.classList.contains("show")){

          let homePanel = document.getElementById("nav-mobile-1");
          homePanel.classList.remove('d-none');
          
          // Hide it
          panel.classList.add("animation-fade-slide-right");
          panel.classList.add("animation-reverse");
          panel.classList.remove('show');

          // Re-hide whole div with d-none when animation is complete
          panel.onanimationend = function() {
            panel.classList.remove("animation-fade-slide-right");
            panel.classList.remove("animation-reverse");
            panel.classList.add('d-none');
            panel.onanimationend = false;
            
          }
        } else {
          // Show it
          panel.classList.add("animation-fade-slide-right");
          panel.classList.add("show");
          panel.classList.remove('d-none');

          panel.onanimationend = function() {
            console.log('we here');
            panel.classList.remove("animation-fade-slide-right");
            panel.onanimationend = false;
            let homePanel = document.getElementById("nav-mobile-1");
            homePanel.classList.add('d-none');
          }
        }
      });
    });

    this.headerSectionElement = document.querySelector('.section-header');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
    
  },

  onScrollDown: function(e) {
    if(e.detail.difference > 5) {
      this.headerSectionElement.classList.remove('scrolled-up');
      this.headerSectionElement.classList.add('scrolled-down');
    }
  },

  onScrollUp: function(e) {
    if(e.detail.difference > 5) {
      this.headerSectionElement.classList.remove('scrolled-down');
      this.headerSectionElement.classList.add('scrolled-up');
    }
  },

  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      var difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }

}

export default Nav;